



























































import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import FoldingCard from '@/components/FoldingCard.vue'
import AppTableDate from '@/components/AppTableDate.vue'
import { Account } from '@/modules/Account/interfaces/account'
import { dateTimeToDisplay } from '@/utils/dateTime'
import { caseStatus, caseType, caseTypeClass } from '@/modules/Case/helpers/case'
import { getCases } from '@/modules/Case/gql/case.gql'
import { ApolloResponse } from '@/interfaces/apollo'
import { showErrors } from '@/utils/snack'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import { translateCaseTypeKey } from '@/utils/translate'
import { Case } from '@/modules/Case/interfaces/case'

import CaseDialog from '@/modules/Case/scripts/case-dialog'
import PolicyDialog from '@/modules/Policy/scripts/policy-dialog'

@Component({
  components: {
    FoldingCard,
    AppTableDate
  }
})
export default class AccountDetailCase extends mixins(CaseDialog, PolicyDialog) {
  @Prop({ type: Object as () => Account }) readonly account!: Account

  accountId: number | null = null

  caseStatus = caseStatus
  caseType = caseType
  caseTypeClass = caseTypeClass
  translateCaseTypeKey = translateCaseTypeKey

  tableColumn = [
    { field: 'id',
      title: 'Case ID',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.id ? row.id : '-')
        ]
      }
      },
      sortable: true,
      resizable: true,
      width: 95,
      fixed: 'left'
    },
    { field: 'inquiryName',
      title: 'Case Name',
      slots: { default: 'name_default' },
      resizable: true,
      sortable: true
    },
    { title: 'Contact Name',
      field: 'primaryContact',
      slots: { default: 'contact_name_default' },
      resizable: true,
      width: 200
    },
    { field: 'type', title: 'Case Type', slots: { default: 'type_default' }, sortable: true, resizable: true, width: 140 },
    { title: 'Creation Time',
      field: 'createdAt',
      slots: {
        default: 'time_default'
      },
      resizable: true,
      sortable: true,
      width: 130
    },
    { title: 'Last Modified Time',
      field: 'updatedAt',
      slots: {
        default: 'update_time_default'
      },
      resizable: true,
      sortable: true,
      width: 160
    },
    {
      title: 'Case Manager',
      field: 'caseManager',
      slots: {
        default: 'case_manager_default'
      },
      resizable: true,
      sortable: false,
      width: 120
    },
    {
      title: 'Verge Staffs',
      field: 'assignedUsers',
      slots: {
        default: 'staff_default'
      },
      resizable: true,
      sortable: false,
      width: 120
    },
    { field: 'closed', title: 'Status', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  orderBy: {
    [key: string]: string
  } = {
    id: 'ID',
    createdAt: 'CREATED_AT',
    caseName: 'CASE_NAME',
    caseType: 'CASE_TYPE'
  }

  cases: Case[] = []

  @Watch('account', { deep: true })
  onAccountUpdated () {
    this.getCases()
  }

  @Emit('refresh')
  onSuccess () {
    // do nothing
  }

  dateTimeToDisplay = dateTimeToDisplay

  get containerheight () {
    const itemHeight = 34 * this.account.cases.length + 66
    return itemHeight > window.innerHeight - 400
      ? window.innerHeight - 400
      : itemHeight
  }

  mounted () {
    this.getCases()
  }

  async getCases () {
    const { sortBy, sortDesc, tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const orderBy = this.orderBy[sortBy] || 'ID'
    this.tableOptions.loading = true
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCases,
        variables: {
          filter: {
            accountId: Number(this.account.id)
          },
          isTop: false,
          isOpen: false,
          paging: {
            offset: (currentPage - 1) * pageSize,
            limit: pageSize
          },
          order: {
            orderBy: orderBy,
            asc: !sortDesc
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.cases = result.data.getCases.cases
      this.tableOptions.loading = false
      this.tableOptions.tablePage.total = result.data.getCases.paging.totalCount
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.getCases()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
    this.getCases()
  }

  routeToDetail (item: any) {
    return {
      name: 'CaseDetailDetail',
      params: {
        id: item.id
      }
    }
  }

  routeToAccountDetail (item: any) {
    if (item.account) {
      return {
        name: 'AccountDetailDetail',
        params: {
          id: item.account.id
        }
      }
    }
  }

  routeToContactDetail (item: any) {
    if (item.primaryContact) {
      return {
        name: 'ContactDetailDetail',
        params: {
          id: item.primaryContact.id
        }
      }
    }
  }

  async deleteCaseConfirm () {
    await this.deleteCasePost()
    this.onSuccess()
  }
}
